import {Component, OnDestroy, OnInit} from '@angular/core';
import {Select, Store} from '@ngxs/store';
import {AppState} from '../../state/appState';
import {Observable, Subscription} from 'rxjs';
import {MerchantModel} from '../../shared/models/merchant.model';
import {GatewayConfigModel} from '../../shared/services/gateway-config/gatewayConfig.model';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {SetupService} from '../../shared/services/setup/setup.service';
import {StartLoading, StopLoading} from '../../state/actions/general.actions';
import {RouteHome, RouteLogin, RouteRegister} from '../../state/actions/routing.actions';
import {distinctUntilChanged, take} from 'rxjs/operators';
import {MerchantStatusEnum} from '../../shared/enum/merchantStatusEnum';
import {Login} from '../../state/actions/merchant.actions';

@Component({
  selector: 'app-email-migration',
  templateUrl: './email-migration.component.html',
  styleUrls: ['./email-migration.component.scss']
})
export class EmailMigrationComponent implements OnInit, OnDestroy {
  @Select(AppState.currentMerchant$)
  currentMerchant$: Observable<MerchantModel>;
  @Select(AppState.gatewayConfig$)
  gatewayConfig$: Observable<GatewayConfigModel>;

  private subs: Subscription[] = [];

  public migrationForm: FormGroup;

  constructor(
    private store: Store,
    private activatedRoute: ActivatedRoute,
    private setupService: SetupService
  ) {
    this.store.dispatch(new StartLoading());
  }

  ngOnInit(): void {
    this.store.dispatch(new StartLoading());
    this.subs.push(
      this.activatedRoute.params.subscribe((p) => {
        if (p.merchantId) {
          this.initForm(p.merchantId);
          this.store.dispatch(new StopLoading());
        } else {
          this.store.dispatch(new RouteLogin());
        }
      })
    );
    this.subs.push(
      this.currentMerchant$.pipe(distinctUntilChanged()).subscribe((p) => {
        if (p != null) {
          this.store.dispatch(new StartLoading());
          this.store.dispatch(new RouteHome());
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }

  initForm(merchantId: string): void {
    this.gatewayConfig$.pipe(take(1)).subscribe((cfg) => {
      this.migrationForm = new FormGroup(
        {
          merchantId: new FormControl(
            {value: merchantId, disabled: true},
            Validators.required
          ),
          email: new FormControl('', [
            Validators.required,
            Validators.email
          ]),
          password: new FormControl('', [
            Validators.required,
          ]),
        },
        []
      );

      this.setupService.searchCard(merchantId).subscribe(
        (cardResponse) => {
          switch (cardResponse.status) {
            case MerchantStatusEnum.EMAIL_MIGRATION:
              break;
            case MerchantStatusEnum.INIT:
              return this.store.dispatch(new RouteRegister(merchantId));
            default:
              return this.store.dispatch(new RouteLogin(merchantId));
          }
        },
        (error) => {
          return this.store.dispatch(new RouteLogin(merchantId));
        }
      );
    });
  }

  onSubmit(): void {
    const {merchantId, password, email} = this.migrationForm.getRawValue();

    this.setupService.migrateToEmail(merchantId, password, email).subscribe(
      () => {
        this.store.dispatch(new Login(email, password));
      },
      ({status}) => {
        switch (status) {
          case 401:
            this.migrationForm.setErrors({wrongPassword: true});
            break;
          case 409:
            this.migrationForm.setErrors({conflict: true});
            break;
          default:
            this.migrationForm.setErrors({unknownError: true});
        }
        this.store.dispatch(new StopLoading());
      }
    );
  }

  onResetForm(): void {
    this.store.dispatch(new RouteLogin(''));
  }
}
